export default "__VITE_ASSET__DhpR4gTV__"